module.exports = __webpack_public_path__ + "images/DefaultFarm_01_2c35dd5187855f9cf4e4c020e0b5613c.jpeg";